/* Publish by EComposer at 2024-06-11 01:29:26*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-5rpawun8aej"]=  window.__ectimmers["ecom-5rpawun8aej"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-5rpawun8aej').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5rpawun8aej', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-90q50lgqv8g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-90q50lgqv8g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oea1ju9ww8p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oea1ju9ww8p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wyte6q5fpun').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wyte6q5fpun', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-61ds0arjkwv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-61ds0arjkwv', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-pvkfm40ri2"]=  window.__ectimmers["ecom-pvkfm40ri2"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-pvkfm40ri2"]["u4mha0l54"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click(),Shopify.analytics.publish("ec_custom_events",{button_id:i.id,tracking_id:i.dataset.ecTrackingId}),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-pvkfm40ri2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pvkfm40ri2', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-asqvgrlybgr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-asqvgrlybgr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7yy5tte75cg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7yy5tte75cg', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-bfnzhdmjvkj"]=  window.__ectimmers["ecom-bfnzhdmjvkj"] || {};
if(!this.settings||!this.$el)return;var e=this.$el.querySelector(".ecom-video_overlay-icon");e&&e.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"){let n=this.$el.querySelector(".ecom_video");n.autoplay=!0,n.load(),this.$el.querySelector(".ecom-video_overlay-icon").classList.remove("ecom-overlay"),this.$el.querySelector(".ecom-video-icon-play").style.display="none"}else{let n=this.$el.querySelector(".ecom_iframe"),s=n.getAttribute("src");s.includes("autoplay=0")?s=s.replace("autoplay=0","autoplay=1"):s=s+"&autoplay=1",n.setAttribute("src",s),this.$el.querySelector(".ecom-video_overlay-icon").classList.remove("ecom-overlay"),this.$el.querySelector(".ecom-video-icon-play").style.display="none"}}),this.$el.querySelectorAll("[data-ec-tracking-id]").forEach(function(n){n.dataset.ecTrackingId&&n.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:n.id,tracking_id:n.dataset.ecTrackingId})},{once:!0})});const i=this.$el.querySelector("[ecom-modal]");if(i&&this.settings.image_overlay&&this.settings.play_on_lightbox&&window.EComModal){var t=this.id;new window.EComModal(i,{cssClass:[t,"ecom-core","ecom-core-simulator"],onOpen:function(){var n=document.querySelector(".ecom-modal."+t);n&&n.querySelector(".ecom-modal-box__content").classList.add("ecom-element_video-iframe")}})}

                    });
                    
                        document.querySelectorAll('.ecom-bfnzhdmjvkj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bfnzhdmjvkj', settings: {"source":"uploaded"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ekvcflbsmte').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ekvcflbsmte', settings: {"source":"uploaded"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u1b8cdz6co').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u1b8cdz6co', settings: {"source":"uploaded"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-5qinp50uu6u"]=  window.__ectimmers["ecom-5qinp50uu6u"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}

                    });
                    
                        document.querySelectorAll('.ecom-5qinp50uu6u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5qinp50uu6u', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ff5y01mhdw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ff5y01mhdw', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}